import { Injectable } from '@angular/core';

/** 真偽の値の文字列 */
enum BooleanString {
  True = 'true',
  False = 'false',
}

@Injectable({
  providedIn: 'root',
})
export class SystemAdminService {
  /** システム管理者であるかの保存先 */
  private readonly systemAdminStorageKey = 'matp.systemadmin';

  /** テナントIDの保存先 */
  private readonly tenantIdStorageKey = 'matp.systemadmin.tenant';

  /** テナント作成日時の保存先 */
  private readonly tenantCreatedAtStorageKey =
    'matp.systemadmin.tenantcreatedat';

  /**
   * システム管理者テナントを選択したことを保存する
   */
  setSystemAdminTenant() {
    sessionStorage.setItem(this.systemAdminStorageKey, BooleanString.True);
  }

  /**
   * テナントIDをセッションストレージに保存する
   * @param tenantId テナントID
   */
  setTenantId(tenantId: string): void {
    sessionStorage.setItem(this.tenantIdStorageKey, tenantId);
  }

  /**
   * テナント作成日時をセッションストレージに保存する
   * @param tenantCreatedAt テナントID
   */
  setTenantCreatedAt(tenantCreatedAt: string | null): void {
    if (!tenantCreatedAt) {
      return;
    }
    sessionStorage.setItem(this.tenantCreatedAtStorageKey, tenantCreatedAt);
  }

  /**
   * セッションストレージからテナントIDを取得する
   * @returns テナントID
   */
  getTenantId(): string | null {
    return sessionStorage.getItem(this.tenantIdStorageKey);
  }

  /**
   * セッションストレージからテナント作成日時を取得する
   * @returns テナントID
   */
  getTenantCreatedAt(): string | null {
    return sessionStorage.getItem(this.tenantCreatedAtStorageKey);
  }

  /**
   * 選択状況をセッションストレージからクリアする
   */
  clear(): void {
    sessionStorage.removeItem(this.systemAdminStorageKey);
    sessionStorage.removeItem(this.tenantIdStorageKey);
    sessionStorage.removeItem(this.tenantCreatedAtStorageKey);
  }

  /** テナント（システム管理者テナントを含む）を選択しているか */
  get isSelectedTenant(): boolean {
    return this.getTenantId() !== null;
  }

  /** システム管理者テナントを選択しているか */
  get isSelectedSystemAdminTenant(): boolean {
    const systemAdmin = sessionStorage.getItem(this.systemAdminStorageKey);
    return systemAdmin === BooleanString.True;
  }
}
